import {
	Button,
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@dune/ui";
import { constructionSiteDocumentTypeLabels } from "@dune/vars";
import { Loader2 } from "lucide-react";
import { useGetReferenceableFiles } from "../../../api/queries/constructionSiteSubmission.queries";

interface ReferenceDocumentModalProps {
	isOpen: boolean;
	onClose: () => void;
	constructionSiteId: number;
	onSelectFile?: (fileId: string) => void;
}

export function ReferenceDocumentModal({
	isOpen,
	onClose,
	constructionSiteId,
	onSelectFile,
}: ReferenceDocumentModalProps) {
	const { data: referenceableFiles, isLoading } =
		useGetReferenceableFiles(constructionSiteId);

	const handleSelectFile = async (fileId: string) => {
		onSelectFile?.(fileId);
		onClose();
	};

	const handleOpenChange = (open: boolean) => {
		if (!open) {
			onClose();
		}
	};

	return (
		<Dialog open={isOpen} onOpenChange={handleOpenChange}>
			<DialogContent className="w-[700px]">
				<DialogHeader>
					<DialogTitle>Référencer un document existant</DialogTitle>
				</DialogHeader>

				<div className="flex-1 overflow-y-auto">
					{isLoading ? (
						<div className="flex items-center justify-center py-8">
							<Loader2 className="w-6 h-6 animate-spin" />
							<span className="ml-2">Chargement des documents...</span>
						</div>
					) : !referenceableFiles || referenceableFiles.length === 0 ? (
						<div className="text-center py-8 text-muted-foreground">
							Aucun document disponible pour le référencement
						</div>
					) : (
						<Table>
							<TableHeader>
								<TableRow>
									<TableHead>Nom</TableHead>
									<TableHead>Type</TableHead>
									<TableHead>Taille</TableHead>
									<TableHead />
								</TableRow>
							</TableHeader>
							<TableBody>
								{referenceableFiles.map((file) => (
									<TableRow key={file.id}>
										<TableCell
											colSpan={1}
											className="font-medium truncate max-w-[450px] min-w-[450px]"
										>
											{file.name}
										</TableCell>
										<TableCell>
											{constructionSiteDocumentTypeLabels[file.type]}
										</TableCell>
										<TableCell>
											<Button
												size="sm"
												onClick={() => handleSelectFile(file.id)}
											>
												Choisir
											</Button>
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					)}
				</div>
			</DialogContent>
		</Dialog>
	);
}
